import React from 'react';
import { Platform } from 'react-native';
import { IconButton } from 'react-native-paper';

import Container from '@src/components/Container';
import Divider from '@src/components/Divider';
import Markdown from '@src/components/Markdown';
import RTLRow from '@src/components/RTLRow';
import ViewPager from '@src/components/ViewPager';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import { useBook } from '@src/database/hooks';
import { Page } from '@src/database/models';
import useAnimatedHeader from '@src/hooks/useAnimatedHeader';

import { ScrollView, Title } from './styled';
import { Props } from './types';
const Screen: React.FC<Props> = ({
  navigation,
  route: {
    params: { id, page = 0 },
  },
}) => {
  const viewPager = React.useRef<any>(null);
  const handleScroll = useAnimatedHeader();
  const book = useBook(String(id));

  const [fontLevel, setFontLevel] = React.useState(0);
  const [pages, setPages] = React.useState<Page[]>([]);

  React.useEffect(() => {
    // setPages([]);
  
    const fetch = async () => {
        if (Platform.OS === 'web') {
        let unSortedPage: Page[] = (await book.data?.pages.fetch()) ?? [];
        setPages(unSortedPage.sort((p1, p2) => p1.order - p2.order));
      } else {
        setPages((await book.data?.sortedPages.fetch()) ?? []);
      }
    };
     fetch().catch((error) => {
      console.log(error)});
  }, [book.data]);

  const handleMenuPress = React.useCallback(
    () => navigation.navigate('PrimeBookMenu', { id }),
    [id, navigation]
  );

  const handleFontLevelPress = React.useCallback(() => {
    if (fontLevel === 4) {
      setFontLevel(0);
    } else {
      setFontLevel(fontLevel + 1);
    }
  }, [fontLevel]);

  React.useLayoutEffect(() => {
    if (book.data) {
      viewPager.current?.setPageWithoutAnimation(page);
    }
  }, [book.data, page,pages]);

  React.useLayoutEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <RTLRow>
          <IconButton
            icon="headphones"
            onPress={() =>
              navigation.navigate('PrimeBookAudioReader', {
                id,
              })
            }
          />
          <Divider vertical />
          <IconButton icon="star" onPress={() => null} />
          <IconButton icon="bars" onPress={handleMenuPress} />
          <IconButton icon="font" onPress={handleFontLevelPress} />
        </RTLRow>
      ),
    });
  }, [handleFontLevelPress, handleMenuPress, id, navigation]);

  if (!pages) {
    return null;
  }

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <ViewPager ref={viewPager} transitionStyle="curl" initialPage={page}>
          {pages.length && pages.map((item) => (
            <ScrollView onScroll={handleScroll} key={item.id}>
              <Title level={fontLevel}>{item.topic?.name}</Title>
              <Markdown level={fontLevel}>{item.text}</Markdown>
            </ScrollView>
          ))}
        </ViewPager>
      </Container>
    </>
  );
};

Screen.displayName = 'PrimeBookTextReader';

export default Screen;
